import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DeviceTypeState {
  id: any;
  systemTypeId: any;
  name: any;
  price: any;
  addition: any;
  producer: any;
  provider: any;
  model: any;
  laborTimeSM: any;
  laborPriceSM: any;
  laborTimePM: any;
  laborPricePM: any;
  minRecomandation: any;
  maxRecomandation: any;
  imageLink: any;
  deviceTypeLabors: any;
  isActive: any;
  props: {
    [key: string]: any;
  };
}

const initialState: DeviceTypeState = {
  id: '',
  systemTypeId: '',
  name: '',
  price: '',
  addition: '',
  producer: '',
  provider: '',
  model: '',
  laborTimeSM: '',
  laborPriceSM: '',
  laborTimePM: '',
  laborPricePM: '',
  minRecomandation: '',
  maxRecomandation: '',
  imageLink: '',
  deviceTypeLabors: null,
  isActive: '',
  props: { isModalVisible: false, refresh: false, isFinish: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const deviceTypeSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    setDevice: (state, action: PayloadAction<Partial<DeviceTypeState>>) => {
      return { ...state, ...action.payload };
    },

    resetDevice: (_state, action: PayloadAction<Partial<DeviceTypeState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: DeviceTypeState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setDevice, resetDevice, updateField, updateProps } = deviceTypeSlice.actions;

export default deviceTypeSlice.reducer;
